import dayjs from 'dayjs'
import { getLocale } from './localeUtils'
import { isBetweenDates } from './isBetweenDates'

export const getValidOfferHandoutLinks = pageContext => {
  const locale = getLocale()
  let DeOfferHandouts
  let AtOfferHandouts
  pageContext?.offerHandouts[0]?.offerRanges.map(item => {
    if (
      isBetweenDates(
        pageContext.dateToday,
        dayjs(item.range[0]).add(4, 'd'),
        item.range[1]
      )
    ) {
      DeOfferHandouts = item.DeOfferHandouts
      AtOfferHandouts = item.AtOfferHandouts
    }
  })
  return locale == 'de' ? DeOfferHandouts : AtOfferHandouts
}
